/**
 * Represents an API error with a message and status code.
 */
export class ApiError extends Error {
  status: number;
  details?: string;
  originalError?: unknown;

  constructor(message: string, status: number, details?: string);
  constructor(message: string, originalError: unknown, status?: number);
  constructor(message: string, statusOrError: number | unknown, detailsOrStatus?: string | number) {
    super(message);
    this.name = 'ApiError';
    
    // Handle overloaded constructor
    if (typeof statusOrError === 'number') {
      // Standard constructor: (message, status, details?)
      this.status = statusOrError;
      this.details = detailsOrStatus as string;
    } else {
      // New constructor: (message, originalError, status?)
      this.originalError = statusOrError;
      this.status = (detailsOrStatus as number) || 500;
      this.details = statusOrError instanceof Error ? statusOrError.message : String(statusOrError);
    }
  }
}
